export enum ProductSurface {
  LeasingPage = 'leasing-page',
  JobsPage = 'jobs-page',
  StayTempe = 'stay-tempe',
  TempeMap = 'tempe-map',
  TempePage = 'tempe-page',
  TempeRentalApplication = 'tempe-rental-application',
  LeasingNavBar = 'leasing-nav-bar',
  LeasingFooter = 'leasing-footer',
  VirtualTour = 'virtual-tour',
  JoinUsForm = 'join-us-form',
  MurphyCrossingPage = 'murphy-crossing-page',
  DillPage = 'dill-allene-page', // dill-allene is a legacy value, now dill and allene have separate pages
  AllenePage = 'allene-page',
  WebLeadForm = 'web-lead-form',
  Amenities = 'amenities',
  LiveEasyApp = 'live-easy-app',
  Home = 'home',
  Settings = 'settings',
}
